module.exports = __webpack_public_path__ + "static/media/Heart.49429849.svg";